import request from '@/utils/request'

export function submitMcht(data) {
  return request({
    url: '/gateway/mng/baseTxn',
    method: 'post',
    data
  })
}


